"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  This reducer create typical reducer for common type of actions { type, payload } only.
 */
var ui_1 = require("../actions/ui");
function default_1(state, action) {
    if (state === void 0) { state = {}; }
    return action.type === ui_1.UPDATE_UI || ui_1.CLEAR_UI ? Object.assign({}, action.payload) : state;
}
exports.default = default_1;
